/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1CoursefinancialCoursefinancialidLangsId200,
  PutApiV1CoursefinancialCoursefinancialidLangsId400,
  PutApiV1CoursefinancialCoursefinancialidLangsId401,
  PutApiV1CoursefinancialCoursefinancialidLangsId404,
  PutApiV1CoursefinancialCoursefinancialidLangsId500,
  PutApiV1CoursefinancialCoursefinancialidLangsIdMutationRequest,
  PutApiV1CoursefinancialCoursefinancialidLangsIdMutationResponse,
  PutApiV1CoursefinancialCoursefinancialidLangsIdPathParams,
} from "../../types/courseFinancialLangsController/PutApiV1CoursefinancialCoursefinancialidLangsId.ts";
import { courseFinancialLangEditorViewModelSchema } from "../courseFinancialLangEditorViewModelSchema.ts";
import { courseFinancialLangViewModelSchema } from "../courseFinancialLangViewModelSchema.ts";

export const putApiV1CoursefinancialCoursefinancialidLangsIdPathParamsSchema =
  z.object({
    courseFinancialId: z.coerce.number().int(),
    id: z.coerce.number().int(),
  }) as unknown as ToZod<PutApiV1CoursefinancialCoursefinancialidLangsIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const putApiV1CoursefinancialCoursefinancialidLangsId200Schema = z.lazy(
  () => courseFinancialLangViewModelSchema,
) as unknown as ToZod<PutApiV1CoursefinancialCoursefinancialidLangsId200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1CoursefinancialCoursefinancialidLangsId400Schema =
  z.any() as unknown as ToZod<PutApiV1CoursefinancialCoursefinancialidLangsId400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1CoursefinancialCoursefinancialidLangsId401Schema =
  z.any() as unknown as ToZod<PutApiV1CoursefinancialCoursefinancialidLangsId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const putApiV1CoursefinancialCoursefinancialidLangsId404Schema =
  z.any() as unknown as ToZod<PutApiV1CoursefinancialCoursefinancialidLangsId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1CoursefinancialCoursefinancialidLangsId500Schema =
  z.any() as unknown as ToZod<PutApiV1CoursefinancialCoursefinancialidLangsId500>;

export const putApiV1CoursefinancialCoursefinancialidLangsIdMutationRequestSchema =
  z.lazy(
    () => courseFinancialLangEditorViewModelSchema,
  ) as unknown as ToZod<PutApiV1CoursefinancialCoursefinancialidLangsIdMutationRequest>;

export const putApiV1CoursefinancialCoursefinancialidLangsIdMutationResponseSchema =
  z.lazy(
    () => putApiV1CoursefinancialCoursefinancialidLangsId200Schema,
  ) as unknown as ToZod<PutApiV1CoursefinancialCoursefinancialidLangsIdMutationResponse>;
